export default {
  loading: 'Ladataan hinnoittelua…',
  default_modal: {
    title: 'Oletushinnasto',
    description:
      'Oletushinnat, jotka periytyvät jokaiselle partnerille, jolla ei ole omaa ylikirjoitusta. Muutokset eivät koskaan vaikuta käynnissä oleviin lisensseihin.',
    saved: 'Oletushinnasto tallennettu.',
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
  toasts: {
    load_error: 'Hinnoittelutietoja ei voitu ladata.',
    save_error: 'Tallennus epäonnistui — yritä uudelleen.',
    prices_saved: 'Hinnasto tallennettu.',
    license_created: 'Lisenssi luotu.',
    lifecycle: {
      pause: 'Lisenssi keskeytetty.',
      resume: 'Lisenssi jatkettu.',
      cancel: 'Lisenssi peruutettu.',
    },
  },
  price_book: {
    title: 'Hinnasto',
    read_only_notice:
      'Partnerin hinnat ylikirjoittavat oletushinnaston. Käynnissä olevat lisenssit säilyttävät lukitut hintansa.',
    editing_notice: 'Muokataan — uudet hinnat koskevat vain tästä eteenpäin luotavia lisenssejä.',
    columns: {
      service: 'Palvelu',
      cost_price: 'Bruttohinta ({{currency}}/kk, sis. ALV)',
    },
    add_ons: 'Lisäosat',
    missing_price: '{{name}} on käytössä, mutta sillä ei ole hintaa — aseta hinta tai poista käytöstä.',
    incomplete_tier:
      '{{name}} tarvitsee sekä volyymihinnan että sijaintimäärän, josta alkaen se pätee, tai ei kumpaakaan.',
    invalid_tier:
      '{{name}}:n volyymihinnan on oltava alle sen vakiohinnan, vähintään 2 aktiivisesta toimipaikasta alkaen.',
    tier: {
      from: 'Volyymihinta alkaen',
      live_locations: 'aktiivista toimipaikkaa',
      counted_one: 'Tämä partneri laskee {{count}} aktiivisen lisensoidun toimipaikan volyymihintaa varten.',
      counted_other: 'Tämä partneri laskee {{count}} aktiivista lisensoitua toimipaikkaa volyymihintaa varten.',
    },
    snapshot_note:
      'Hinnat lukitaan lisenssiin sen luontihetkellä — hinnaston muokkaaminen ei koskaan muuta käynnissä olevia lisenssejä.',
    types: {
      base: 'Perus',
      add_on: 'Lisäosa',
    },
  },
  volume_discount: {
    title: 'Määräalennus',
    read_only_notice:
      'Kun kuukausilaskulla ylittyy lisenssien kynnysmäärä, alennus vähennetään kaikista kyseisen jakson lisenssimaksuista.',
    editing_notice: 'Muokataan — uudet asetukset tulevat voimaan seuraavasta laskutusjaksosta alkaen.',
    threshold_label: 'Lisenssikynnys',
    percent_label: 'Alennus',
    invalid: 'Anna vähintään 1:n kynnys ja alennus väliltä 0–100 %.',
    saved: 'Volyymialennus tallennettu.',
    note: 'Laskee vain kyseisen jakson laskutetut lisenssit; siirretyt kuukaudet eivät sisälly. 0 % (oletus) poistaa alennuksen käytöstä — muuten se kertautuisi hinnaston volyymihinnan päälle.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Testiravintolaa ei koskaan laskuteta, joten sillä ei voi olla lisenssiä.',
    title: 'Ravintolalisenssit',
    select_company: 'Valitse ravintola',
    add_license: 'Lisää lisenssi',
    no_companies: 'Tällä kumppanilla ei ole vielä ravintoloita.',
    no_licenses: 'Tällä ravintolalla ei ole vielä lisenssejä.',
    activated_at: 'Aktiivinen alkaen',
    next_period_preview: 'Seuraava kuukausi (suhteutettu, ennen volyymialennusta)',
    statuses: {
      active: 'Aktiivinen',
      paused: 'Keskeytetty',
      canceled: 'Peruutettu',
    },
    columns: {
      product: 'Palvelu',
      locked_price: 'Lukittu hinta / kk',
      quantity: 'Määrä',
      trial_ends: 'Ilmainen asti',
    },
    price_tiers: {
      volume: 'Volyymihinta',
      locked: 'Vanha hinta',
    },
  },
  lifecycle: {
    pause: {
      action: 'Keskeytä',
      title: 'Keskeytetäänkö tämä lisenssi?',
      description:
        'Keskeytettyjä päiviä ei laskuteta. Lisenssi säilyttää lukitut hinnat ja sen voi jatkaa milloin tahansa.',
      confirm: 'Keskeytä',
    },
    resume: {
      action: 'Jatka',
      title: 'Jatketaanko tätä lisenssiä?',
      description: 'Laskutus jatkuu tästä päivästä lukituilla hinnoilla.',
      confirm: 'Jatka',
    },
    cancel: {
      action: 'Peruuta lisenssi',
      title: 'Peruutetaanko tämä lisenssi?',
      description:
        'Kuluva kuukausi laskutetaan suhteutettuna tähän päivään asti. Tätä ei voi perua — uusi lisenssi luotaisiin nykyisillä hinnastohinnoilla.',
      confirm: 'Peruuta lisenssi',
    },
  },
  add_license: {
    title: 'Lisää lisenssi',
    description: 'Valitse tälle ravintolalle palvelut. Hinnat lukitaan lisenssiin luontihetkellä.',
    per_month: ' / kk',
    create: 'Luo lisenssi',
    no_priced_products:
      'Yhdelläkään tuotteella ei vielä ole käyttökelpoista hintaa tälle kumppanille — aseta ensin hinnasto.',
  },
};
